import { useMemo } from 'react';
import { useModuleType } from './useModuleType';

export const usePermissions = (userType, allPermissions, specificRoute = null, explicitModuleType = null) => {
  const derivedModuleType = useModuleType(specificRoute);
  const moduleType = explicitModuleType || derivedModuleType;

  const permissions = useMemo(() => {
    if (userType === 'ADMIN') {
      return { VIEW: true, CREATE: true, EDIT: true, DELETE: true };
    }

    if (!moduleType) {
      return { VIEW: false, CREATE: false, EDIT: false, DELETE: false };
    }

    const actionTypes = allPermissions[moduleType];

    if (!actionTypes) {
      return { VIEW: false, CREATE: false, EDIT: false, DELETE: false };
    }

    return actionTypes;
  }, [userType, moduleType, allPermissions]);

  return permissions;
};
